import { formatDateTime, formatTime } from "../../lib/format";
import { HISTORY_LABEL, dayHoursLabel } from "../../lib/regularisation";

const DOT = {
    approved: "bg-emerald-500", modified: "bg-indigo-500", rejected: "bg-rose-500",
    withdrawn: "bg-slate-400", submitted: "bg-amber-500", drafted: "bg-slate-300",
};

function Snapshot({ label, v }) {
    if (!v) return null;
    const parts = [v.attendance_status || "No record"];
    if (v.check_in_time) parts.push(`in ${formatTime(v.check_in_time)}`);
    if (v.check_out_time) parts.push(`out ${formatTime(v.check_out_time)}`);
    if (v.net_working_minutes != null) parts.push(dayHoursLabel(v.net_working_minutes, v.credited_minutes, "0h 00m"));
    return <span><span className="text-slate-400">{label}:</span> {parts.join(" · ")}</span>;
}

export function RequestHistory({ request }) {
    const items = request?.history || [];
    if (!items.length) return null;
    return (
        <div className="border border-slate-200 rounded-md p-3" data-testid="rgz-history">
            <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-2">History</div>
            {request.original_attendance && (
                <div className="text-xs text-slate-600 mb-2" data-testid="rgz-history-original">
                    <Snapshot label="Original attendance" v={request.original_attendance} />
                </div>
            )}
            <ol className="relative border-l border-slate-200 ml-1.5 space-y-3">
                {items.map((h, i) => {
                    const key = (h.action || "").replace("override_", "");
                    return (
                        <li key={i} className="pl-4" data-testid={`rgz-history-item-${i}`}>
                            <span className={`absolute -left-[5px] mt-1 h-2.5 w-2.5 rounded-full ${DOT[key] || "bg-slate-400"}`} />
                            <div className="text-xs font-medium text-slate-800">
                                {HISTORY_LABEL[h.action] || h.action}
                                <span className="font-normal text-slate-500"> · {h.actor_name || h.actor_email || "system"} · {formatDateTime(h.at)}</span>
                            </div>
                            {h.reason && <div className="text-xs text-slate-600 mt-0.5 italic">&ldquo;{h.reason}&rdquo;</div>}
                            {(h.old || h.new) && h.action !== "submitted" && h.action !== "drafted" && (
                                <div className="text-[11px] text-slate-500 mt-0.5 flex flex-col">
                                    <Snapshot label="Before" v={h.old} />
                                    <Snapshot label="After" v={h.new} />
                                </div>
                            )}
                        </li>
                    );
                })}
            </ol>
        </div>
    );
}

export default RequestHistory;
